import adminApi from "../../api";

class AdminPromotionsService {
  async list() {
    const response = await adminApi.get("/promotions");
    return response.data;
  }

  async create({ description, startsAt, endsAt, sortOrder, imageFile }) {
    const formData = new FormData();
    formData.append("description", description);
    if (startsAt) formData.append("starts_at", startsAt);
    if (endsAt) formData.append("ends_at", endsAt);
    if (sortOrder !== undefined && sortOrder !== null) {
      formData.append("sort_order", String(sortOrder));
    }
    if (imageFile) formData.append("image", imageFile);

    const response = await adminApi.post("/promotions", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async update(id, { description, startsAt, endsAt, sortOrder, imageFile }) {
    const formData = new FormData();
    if (description !== undefined) formData.append("description", description);
    if (startsAt !== undefined) formData.append("starts_at", startsAt || "");
    if (endsAt !== undefined) formData.append("ends_at", endsAt || "");
    if (sortOrder !== undefined && sortOrder !== null) {
      formData.append("sort_order", String(sortOrder));
    }
    if (imageFile) formData.append("image", imageFile);

    const response = await adminApi.put(`/promotions/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }

  async delete(id) {
    const response = await adminApi.delete(`/promotions/${id}`);
    return response.data;
  }
}

export default new AdminPromotionsService();

